/*

File handles all api calls for tenants


*/
import { browserHistory } from 'react-router'
import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var Listing = Class.create({
  	initialize: function() {
  		this.server = server;
	},

	getListing: function(id, callback) {
		var url = "listing/" + id;
		var data = this.server.getData(url, null, true);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
				// #  Display error
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
            }

            callback(response);

		})
		.fail(function(e){
			modal.showInfo("Oops! Something went wrong!", "danger", "top", "center");
		});
	},
	deleteListing: function(id, callback) {
		// #  Localize this instance for use on success
      var self = this;
      // #  Send out success message
      modal.showDangerModalWithOK("Are you sure?","You are about to delete this listing.  All data associated will be deleted and you will not be able to recover.","Yes, Delete");
      // #  Bind okay button
      jQuery(".move-on").on('click',function() {
		// prepare our data to be sent
		var url = "listing/" + id;
		// #  Send to server object for processing
		var data = self.server.getData(url, null, true, "DELETE");
	    // #  Listen to our data
        data
        .done(function(response){
          // #  Validate response
          if(response.status == 1 || response.status == 2)
          {
            // #  Display error
            modal.showInfo("Oops! Something went wrong!", "danger", "top", "center");
          }
          else if(response.data.error != null)
          {
            modal.showInfo("Error occurred: " + response.data.error + ". Please try again", "danger", "top", "center");
          }
          else
          {
            // # .Hard reset backdrop
			modal.resetBackDrop();
            callback();
          }
        })
        .fail(function(e){
            modal.showInfo("Oops! Something went wrong!", "danger", "top", "center");
        });
      });
	},
	saveListing: function(data, callback) {
		var self = this;
		var url = "listing/new";
		var data = this.server.getData(url, data, true, "POST");
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				callback(response);
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
    },
    updateListing: function(data, callback) {
		var self = this;
		var url = "listing/" + data.listingId;
		var data = this.server.getData(url, data, true, "PUT");
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				callback(response);
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
    },
    removedImage: function(id, callback) {
		var url = "listing/image/" + id;
		var data = this.server.getData(url, null, true, "DELETE");
        data
        .done(function(response){
          // #  Validate response
          if(response.status == 1 || response.status == 2)
          {
            // #  Display error
            modal.showInfo("Oops! Something went wrong!", "danger", "top", "center");
          }
          else if(response.data.error != null)
          {
            modal.showInfo("Error occurred: " + response.data.error + ". Please try again", "danger", "top", "center");
          }
          else
          {
            callback();
          }
        })
        .fail(function(e){
            modal.showInfo("Oops! Something went wrong!", "danger", "top", "center");
        });
    }
});

export let listing = new Listing();


// WEBPACK FOOTER //
// app/core/controllers/Listing.js